import { useEffect, useRef } from "react";
import { Link } from 'react-router-dom'
import $ from "jquery";
import jszip from "jszip";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.vfs;

const CoachManagement = () => {

    const table1 = useRef(null);
    const table2 = useRef(null);
    const table3 = useRef(null);

    useEffect(() => {
        window.JSZip = jszip;

        let table11, table12, table13;

        if (table1.current) {
            table11 = $(table1.current).DataTable({
                responsive: true,
                pageLength: 5,
                lengthChange: false,
                ordering: true,
                destroy: true,
                dom:
                    "<'row mb-3'<'col-sm-12 col-md-12'f>>" +
                    "<'row'<'col-sm-12'tr>>" +
                    "<'row mt-3'<'col-sm-12 col-md-12'i><'col-sm-12 col-md-12'B p>>",
                buttons: [
                    { extend: "copy", text: "Copy" },
                    { extend: "excel", text: "Excel" },
                    { extend: "pdf", text: "PDF" },
                    { extend: "print", text: "Print" },
                ],
            });
        }

        if (table2.current) {
            table12 = $(table2.current).DataTable({
                responsive: true,
                pageLength: 5,
                lengthChange: false,
                ordering: true,
                destroy: true,
                dom:
                    "<'row mb-3'<'col-sm-12 col-md-12'f>>" +
                    "<'row'<'col-sm-12'tr>>" +
                    "<'row mt-3'<'col-sm-12 col-md-12'i><'col-sm-12 col-md-12'B p>>",
                buttons: [
                    { extend: "copy", text: "Copy" },
                    { extend: "excel", text: "Excel" },
                    { extend: "pdf", text: "PDF" },
                    { extend: "print", text: "Print" },
                ],
            });
        }
        if (table3.current) {
            table13 = $(table3.current).DataTable({
                responsive: true,
                pageLength: 5,
                lengthChange: false,
                ordering: true,
                destroy: true,
                dom:
                    "<'row mb-3'<'col-sm-12 col-md-12'f>>" +
                    "<'row'<'col-sm-12'tr>>" +
                    "<'row mt-3'<'col-sm-12 col-md-12'i><'col-sm-12 col-md-12'B p>>",
                buttons: [
                    { extend: "copy", text: "Copy" },
                    { extend: "excel", text: "Excel" },
                    { extend: "pdf", text: "PDF" },
                    { extend: "print", text: "Print" },
                ],
            });
        }
        return () => {
            if (table11) table11.destroy();
            if (table12) table12.destroy();
            if (table13) table13.destroy();
        };
    }, []);

    return (
        <>
            <div className="page-wrapper">
                <div className="page-content">
                    <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3">Coach Management</div>
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item"><Link to="/"><i className="bx bx-home-alt" /></Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">Coach Management</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <hr />
                    <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#invite_coach" className="d-flex align-items-center btn btn-primary font-18 ms-auto mb-3" style={{ width: 'fit-content' }}>
                        <i className="bx bx-plus ms-1" /> <span>Invite Coach</span>
                    </Link>
                    <div className="card">
                        <div className="card-body">
                            <ul className="nav nav-tabs inner-tab">
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link active" id="all-tabs" data-bs-toggle="tab" data-bs-target="#allTab" type="button" role="tab">All</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="pending-tabs" data-bs-toggle="tab" data-bs-target="#pendingTab" type="button" role="tab">Pending</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="onboarded-tabs" data-bs-toggle="tab" data-bs-target="#onboardedTab" type="button" role="tab">Onboarded</button>
                                </li>
                            </ul>
                            <div className="tab-content">
                                <div className="tab-pane fade show active" id="allTab" role="tabpanel">
                                    <div className="table-responsive">
                                        <div className="entries-wrapper mb-3">
                                            <label className="entries-label">
                                                <span>Showing</span>
                                                <select className="entries-select">
                                                    <option value={10} selected>10</option>
                                                    <option value={25}>25</option>
                                                    <option value={50}>50</option>
                                                    <option value={100}>100</option>
                                                </select>
                                                <span>Entries</span>
                                            </label>
                                        </div>
                                        <table ref={table1} className="table table-striped table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Photo</th>
                                                    <th>Name</th>
                                                    <th>Email</th>
                                                    <th>Phone Number</th>
                                                    <th>Experience</th>
                                                    <th>Team Assigned</th>
                                                    <th>Match count</th>
                                                    <th>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr data-id={1} data-blocked="false">
                                                    <td>
                                                        <img src="images/avatars/avatar-1.png" className="product-img-2" alt="John Clark" />
                                                    </td>
                                                    <td>John Clark</td>
                                                    <td>john_clark@gmail.com</td>
                                                    <td>+0 000-0000-0000</td>
                                                    <td>Senior (10 Years)</td>
                                                    <td>Red Dragons</td>
                                                    <td>55</td>
                                                    <td>Assigned</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center gap-2">
                                                            <li>
                                                                <Link to="/coach-detail"><i className="lni lni-eye" title="View Profile" data-bs-toggle="tooltip" data-bs-placement="top" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#sendNotificationModal">
                                                                    <i className="bx bx-send" data-bs-toggle="tooltip" title="Send Invite" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr data-id={2} data-blocked="false">
                                                    <td>
                                                        <img src="images/avatars/avatar-7.png" className="product-img-2" alt="Robert Sean" />
                                                    </td>
                                                    <td>Robert Sean</td>
                                                    <td>robert_sean@gmail.com</td>
                                                    <td>+0 000-0000-0000</td>
                                                    <td>Intermediate (5 Years)</td>
                                                    <td>Skyline Warriors</td>
                                                    <td>69</td>
                                                    <td>Pending</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center gap-2">
                                                            <li>
                                                                <Link to="/coach-detail"><i className="lni lni-eye" title="View Profile" data-bs-toggle="tooltip" data-bs-placement="top" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#sendNotificationModal">
                                                                    <i className="bx bx-send" data-bs-toggle="tooltip" title="Send Invite" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr data-id={3} data-blocked="false">
                                                    <td>
                                                        <img src="images/avatars/avatar-8.png" className="product-img-2" alt="Richard Thomas" />
                                                    </td>
                                                    <td>Richard Thomas</td>
                                                    <td>richard_thomas@gmail.com</td>
                                                    <td>+0 000-0000-0000</td>
                                                    <td>Junior (2 Years)</td>
                                                    <td>Thunder Kings</td>
                                                    <td>30</td>
                                                    <td>Onboarded</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center gap-2">
                                                            <li>
                                                                <Link to="/coach-detail"><i className="lni lni-eye" title="View Profile" data-bs-toggle="tooltip" data-bs-placement="top" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#sendNotificationModal">
                                                                    <i className="bx bx-send" data-bs-toggle="tooltip" title="Send Invite" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr data-id={4} data-blocked="false">
                                                    <td>
                                                        <img src="images/avatars/avatar-4.png" className="product-img-2" alt="Michael Johnson" />
                                                    </td>
                                                    <td>Michael Johnson</td>
                                                    <td>michael_johnson@gmail.com</td>
                                                    <td>+0 000-0000-0000</td>
                                                    <td>Senior (8 Years)</td>
                                                    <td>Night Owls</td>
                                                    <td>101</td>
                                                    <td>Assigned</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center gap-2">
                                                            <li>
                                                                <Link to="/coach-detail"><i className="lni lni-eye" title="View Profile" data-bs-toggle="tooltip" data-bs-placement="top" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#sendNotificationModal">
                                                                    <i className="bx bx-send" data-bs-toggle="tooltip" title="Send Invite" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="pendingTab" role="tabpanel">
                                    <div className="table-responsive">
                                        <div className="entries-wrapper mb-3">
                                            <label className="entries-label">
                                                <span>Showing</span>
                                                <select className="entries-select">
                                                    <option value={10} selected>10</option>
                                                    <option value={25}>25</option>
                                                    <option value={50}>50</option>
                                                    <option value={100}>100</option>
                                                </select>
                                                <span>Entries</span>
                                            </label>
                                        </div>
                                        <table ref={table2} className="table table-striped table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Photo</th>
                                                    <th>Name</th>
                                                    <th>Email</th>
                                                    <th>Phone Number</th>
                                                    <th>Experience</th>
                                                    <th>Team Assigned</th>
                                                    <th>Match count</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr data-id={1} data-blocked="false">
                                                    <td>
                                                        <img src="images/avatars/avatar-1.png" className="product-img-2" alt="John Clark" />
                                                    </td>
                                                    <td>John Clark</td>
                                                    <td>john_clark@gmail.com</td>
                                                    <td>+0 000-0000-0000</td>
                                                    <td>Senior (10 Years)</td>
                                                    <td>Red Dragons</td>
                                                    <td>55</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center gap-2">
                                                            <li>
                                                                <Link to="/coach-detail"><i className="lni lni-eye" title="View Profile" data-bs-toggle="tooltip" data-bs-placement="top" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#sendNotificationModal">
                                                                    <i className="bx bx-send" data-bs-toggle="tooltip" title="Send Invite" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr data-id={2} data-blocked="false">
                                                    <td>
                                                        <img src="images/avatars/avatar-7.png" className="product-img-2" alt="Robert Sean" />
                                                    </td>
                                                    <td>Robert Sean</td>
                                                    <td>robert_sean@gmail.com</td>
                                                    <td>+0 000-0000-0000</td>
                                                    <td>Intermediate (5 Years)</td>
                                                    <td>Skyline Warriors</td>
                                                    <td>69</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center gap-2">
                                                            <li>
                                                                <Link to="/coach-detail"><i className="lni lni-eye" title="View Profile" data-bs-toggle="tooltip" data-bs-placement="top" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#sendNotificationModal">
                                                                    <i className="bx bx-send" data-bs-toggle="tooltip" title="Send Invite" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr data-id={3} data-blocked="false">
                                                    <td>
                                                        <img src="images/avatars/avatar-8.png" className="product-img-2" alt="Richard Thomas" />
                                                    </td>
                                                    <td>Richard Thomas</td>
                                                    <td>richard_thomas@gmail.com</td>
                                                    <td>+0 000-0000-0000</td>
                                                    <td>Junior (2 Years)</td>
                                                    <td>Thunder Kings</td>
                                                    <td>30</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center gap-2">
                                                            <li>
                                                                <Link to="/coach-detail"><i className="lni lni-eye" title="View Profile" data-bs-toggle="tooltip" data-bs-placement="top" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#sendNotificationModal">
                                                                    <i className="bx bx-send" data-bs-toggle="tooltip" title="Send Invite" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr data-id={4} data-blocked="false">
                                                    <td>
                                                        <img src="images/avatars/avatar-4.png" className="product-img-2" alt="Michael Johnson" />
                                                    </td>
                                                    <td>Michael Johnson</td>
                                                    <td>michael_johnson@gmail.com</td>
                                                    <td>+0 000-0000-0000</td>
                                                    <td>Senior (8 Years)</td>
                                                    <td>Night Owls</td>
                                                    <td>101</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center gap-2">
                                                            <li>
                                                                <Link to="/coach-detail"><i className="lni lni-eye" title="View Profile" data-bs-toggle="tooltip" data-bs-placement="top" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#sendNotificationModal">
                                                                    <i className="bx bx-send" data-bs-toggle="tooltip" title="Send Invite" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="onboardedTab" role="tabpanel">
                                    <div className="table-responsive">
                                        <div className="entries-wrapper mb-3">
                                            <label className="entries-label">
                                                <span>Showing</span>
                                                <select className="entries-select">
                                                    <option value={10} selected>10</option>
                                                    <option value={25}>25</option>
                                                    <option value={50}>50</option>
                                                    <option value={100}>100</option>
                                                </select>
                                                <span>Entries</span>
                                            </label>
                                        </div>
                                        <table ref={table3} className="table table-striped table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Photo</th>
                                                    <th>Name</th>
                                                    <th>Email</th>
                                                    <th>Phone Number</th>
                                                    <th>Experience</th>
                                                    <th>Team Assigned</th>
                                                    <th>Match count</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr data-id={1} data-blocked="false">
                                                    <td>
                                                        <img src="images/avatars/avatar-1.png" className="product-img-2" alt="John Clark" />
                                                    </td>
                                                    <td>John Clark</td>
                                                    <td>john_clark@gmail.com</td>
                                                    <td>+0 000-0000-0000</td>
                                                    <td>Senior (10 Years)</td>
                                                    <td>Red Dragons</td>
                                                    <td>55</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center gap-2">
                                                            <li>
                                                                <Link to="/coach-detail"><i className="lni lni-eye" title="View Profile" data-bs-toggle="tooltip" data-bs-placement="top" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#sendNotificationModal">
                                                                    <i className="bx bx-send" data-bs-toggle="tooltip" title="Send Invite" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr data-id={2} data-blocked="false">
                                                    <td>
                                                        <img src="images/avatars/avatar-7.png" className="product-img-2" alt="Robert Sean" />
                                                    </td>
                                                    <td>Robert Sean</td>
                                                    <td>robert_sean@gmail.com</td>
                                                    <td>+0 000-0000-0000</td>
                                                    <td>Intermediate (5 Years)</td>
                                                    <td>Skyline Warriors</td>
                                                    <td>69</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center gap-2">
                                                            <li>
                                                                <Link to="/coach-detail"><i className="lni lni-eye" title="View Profile" data-bs-toggle="tooltip" data-bs-placement="top" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#sendNotificationModal">
                                                                    <i className="bx bx-send" data-bs-toggle="tooltip" title="Send Invite" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr data-id={3} data-blocked="false">
                                                    <td>
                                                        <img src="images/avatars/avatar-8.png" className="product-img-2" alt="Richard Thomas" />
                                                    </td>
                                                    <td>Richard Thomas</td>
                                                    <td>richard_thomas@gmail.com</td>
                                                    <td>+0 000-0000-0000</td>
                                                    <td>Junior (2 Years)</td>
                                                    <td>Thunder Kings</td>
                                                    <td>30</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center gap-2">
                                                            <li>
                                                                <Link to="/coach-detail"><i className="lni lni-eye" title="View Profile" data-bs-toggle="tooltip" data-bs-placement="top" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#sendNotificationModal">
                                                                    <i className="bx bx-send" data-bs-toggle="tooltip" title="Send Invite" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr data-id={4} data-blocked="false">
                                                    <td>
                                                        <img src="images/avatars/avatar-4.png" className="product-img-2" alt="Michael Johnson" />
                                                    </td>
                                                    <td>Michael Johnson</td>
                                                    <td>michael_johnson@gmail.com</td>
                                                    <td>+0 000-0000-0000</td>
                                                    <td>Senior (8 Years)</td>
                                                    <td>Night Owls</td>
                                                    <td>101</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center gap-2">
                                                            <li>
                                                                <Link to="/coach-detail"><i className="lni lni-eye" title="View Profile" data-bs-toggle="tooltip" data-bs-placement="top" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#sendNotificationModal">
                                                                    <i className="bx bx-send" data-bs-toggle="tooltip" title="Send Invite" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="modal fade" id="sendNotificationModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Confirmation Alert!</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <div className="create_noti_form">
                                <h5>Do you want to send this?</h5>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">No</button>
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal">Yes</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="invite_coach" tabIndex={-1} aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header ">
                            <h5 className="modal-title">Confirmation Alert!</h5>
                            <button type="button" className="btn-close " data-bs-dismiss="modal" />
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="row">
                                    <div className="col-lg-12 mb-3">
                                        <label className="mb-3">Enter Coach Email</label>
                                        <input type="text" className="form-control" defaultValue="john_clark@gmail.com" />
                                    </div>
                                    <div className="col-lg-12">
                                        <label className="mb-3">Message</label>
                                        <textarea className="form-control" defaultValue={""} />
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal">Send Invite</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CoachManagement